<section class="col-seleccion">
  <div class="tituloInt tituloVentas">
    {{ 'INFORMACION_LOCALIZADOR' | translateV2 }}
  </div>
  <div class="DetalleBox" *ngIf="reserva; else cargando">
    <div class="cols">
      <div class="col-left">
        <dl>
          <dt>{{ 'NUMERO_PEDIDO' | translateV2 : 'CAPITALIZE' }}:</dt>
          <dd>{{ reserva.NumeroPedido }}</dd>
          <dt>{{ 'LOCALIZADOR' | translateV2 : 'CAPITALIZE' }}:</dt>
          <dd>{{ reserva.ClaveReserva }}</dd>
          <ng-container *ngIf="reserva.NumVenta">
            <dt>Nº {{ 'VENTA' | translateV2 : 'CAPITALIZE' }}:</dt>
            <dd>{{ reserva.NumVenta }}</dd>
          </ng-container>
          <!-- <ng-container *ngIf="reserva.FPDenominacion !== ''">
            <dt>{{ 'PAGO' | translateV2:'CAPITALIZE' }}:</dt>
            <dd>{{ reserva.FPDenominacion }}</dd>
          </ng-container> -->
          <ng-container *ngIf="reserva.ReservaFOPs.length > 0">
            <dt>{{ 'FORMA_PAGO' | translate }}:</dt>
            <dd>
              <table class="fop-table">
                <!-- FOPs que no son SP -->
                <ng-container *ngFor="let fop of reserva.ReservaFOPs">
                  <ng-container *ngIf="fop.Importe !== '0' && fop.FOP !== 'SP'">
                    <tr>
                      <td>{{ fop.FOP }}</td>
                      <td>
                        {{
                          fop.Importe
                            | myCurrency
                              : divisaSimboloDecimal
                              : divisaDecimales
                              : divisaPosicion
                              : divisaSimbolo
                              : divisaSimboloDerecha
                              : divisaSimbSeparacionMiles
                        }}
                      </td>
                    </tr>
                  </ng-container>
                </ng-container>

                <!-- FOPs que son SP (SINPE), mostrados agrupados -->
                <ng-container *ngIf="tieneFOPSINPE">
                  <tr>
                    <td colspan="2"><strong>SINPE</strong></td>
                  </tr>
                  <ng-container *ngFor="let fop of reserva.ReservaFOPs">
                    <ng-container
                      *ngIf="fop.FOP === 'SP' && fop.Importe !== '0'"
                    >
                      <tr>
                        <td>
                          {{
                            fop.OperacionesSINPE &&
                              fop.OperacionesSINPE.CodReferencia
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          {{
                            fop.Importe
                              | myCurrency
                                : divisaSimboloDecimal
                                : divisaDecimales
                                : divisaPosicion
                                : divisaSimbolo
                                : divisaSimboloDerecha
                                : divisaSimbSeparacionMiles
                          }}
                        </td>
                      </tr>
                      <tr
                        *ngIf="
                          fop.OperacionesSINPE &&
                          fop.OperacionesSINPE.Estado === '0'
                        "
                      >
                        <td colspan="2">{{ 'SIN_VINCULAR' | translate }}</td>
                      </tr>
                    </ng-container>
                  </ng-container>
                </ng-container>
              </table>
            </dd>
          </ng-container>
          <ng-container
            *ngIf="
              reserva.Descuento &&
              (formatearPrecio(reserva.Descuento) > 0 ||
                formatearPrecio(reserva.Descuento) < 0)
            "
          >
            <dt>{{ 'TOTALDESCUENTO' | translateV2 : 'CAPITALIZE' }}:</dt>
            <dd>{{ reserva.Descuento }}</dd>
          </ng-container>
          <ng-container
            *ngIf="reserva.CodigoClienteId && reserva.CodigoClienteId !== '0'"
          >
            <dt>{{ 'CLIENTE' | translateV2 : 'CAPITALIZE' }}:</dt>
            <dd>{{ reserva.CodigoClienteId }} - {{ reserva.NombreCliente }}</dd>
          </ng-container>
          <ng-container *ngIf="reserva.DniResponsable">
            <dt>CIF/DNI/NIE:</dt>
            <dd>
              {{ reserva.DniResponsable }}
            </dd>
          </ng-container>
          <ng-container *ngIf="reserva.NombreResponsable">
            <dt>{{ 'CONTACTO' | translateV2 : 'CAPITALIZE' }}:</dt>
            <dd>{{ reserva.NombreResponsable }}</dd>
          </ng-container>
          <ng-container *ngIf="reserva.Email">
            <dt>Email:</dt>
            <dd>{{ reserva.Email }}</dd>
          </ng-container>
          <ng-container>
            <dt>{{ 'NOTAS' | translateV2 : 'CAPITALIZE' }}:</dt>
            <dd>
              <span
                *ngIf="reserva && reserva.Notas"
                [innerHTML]="reserva.Notas"
              >
              </span>
              <span
                *ngIf="reserva && reserva.NotasInternas"
                [innerHTML]="reserva.NotasInternas"
              >
              </span>
            </dd>
          </ng-container>

          <ng-container
            *ngIf="
              reserva.ReservaItems &&
              reserva.ReservaItems[0] &&
              reserva.ReservaItems[0].ListaReimpresion &&
              reserva.ReservaItems[0].ListaReimpresion[0]
            "
          >
            <dt>{{ 'NUM_REIMPRESIONES' | translateV2 : 'CAPITALIZE' }}:</dt>
            <dd>
              {{ reserva.ReservaItems[0].ListaReimpresion[0].NumReimpresiones }}
            </dd>
          </ng-container>
          <ng-container *ngIf="reserva.Facturado !== '0'">
            <dt>{{ 'FACTURA' | translateV2 : 'CAPITALIZE' }}:</dt>
            <dd>
              <span> {{ reserva.SerieFactura }} {{ reserva.NumFactura }}</span>
              <a class="print" title="Imprimir">
                <img
                  class="svg"
                  src="assets/img/icon-print.svg"
                  alt="icono Imprimir"
                />
              </a>
            </dd>
          </ng-container>
        </dl>
      </div>
      <div class="col-right">
        <div class="resultado">
          <div class="data">
            <span>{{ getStatus(reserva.Status) }}</span>
            <span class="small" *ngIf="reserva.FechaHoraEntrada"
              >{{ 'FECHA_VENCIMIENTO' | translateV2 : 'CAPITALIZE' }}:
              {{ reserva.FechaHoraEntrada }}</span
            >
            <span class="small" *ngIf="!reserva.FechaHoraEntrada"
              >{{ 'FECHA_VENCIMIENTO' | translateV2 : 'CAPITALIZE' }}:
              {{ 'SIN_VENCIMIENTO' | translateV2 : 'CAPITALIZE' }}</span
            >
          </div>
        </div>
        <div class="tit-historico">
          {{ 'HISTORICO_LOCALIZADOR' | translateV2 }}:
        </div>
        <perfect-scrollbar class="scroll-historico">
          <ul>
            <li *ngFor="let evento of reserva.ReservaHistorial">
              {{ getEvento(evento.TipoAccion) }}
              {{ evento.Fecha | formatFecha }}
              {{ evento.Hora | formatHora }}
              <span *ngIf="evento.Cantidad > 1">({{ evento.Cantidad }})</span>
            </li>
          </ul>
        </perfect-scrollbar>
      </div>
    </div>
  </div>
  <ng-template #cargando>
    <div class="DetalleBox__noResultsMessage">
      <div class="lds-ring">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  </ng-template>
  <div *ngIf="reserva" class="btn-bottom-wrap" style="margin-bottom: 1px">
    <a class="SiguienteButton" (click)="volver()">
      {{ 'ANTERIOR' | translateV2 }}
    </a>
    <a
      class="SiguienteButton"
      *ngIf="tienePermiso('LocalizadorImprimir')"
      [ngClass]="{ disabled: !sePuedeImprimir }"
      (click)="reimprimirReserva()"
      >{{ 'IMPRIMIR' | translateV2 }}</a
    >
    <a
      class="GestionarButton"
      *ngIf="tienePermiso('LocalizadorAceptar')"
      [ngClass]="{ disabled: !sePuedeAceptar }"
      (click)="modificarReserva()"
      style="margin-top: 14px"
      >{{ 'SIGUIENTE' | translateV2 }}</a
    >
  </div>
</section>
<section class="col-resumen">
  <div class="cliente-fecha" *ngIf="reserva; else cargando">
    <perfect-scrollbar class="cliente-fecha ps--active-y">
      <span *ngIf="reserva.ClaveReserva"> {{ reserva.ClaveReserva }}</span>
      <span
        *ngIf="
          reserva.CodigoClienteId &&
          reserva.CodigoClienteId !== '0' &&
          reserva.NombreCliente
        "
        >{{ reserva.NombreCliente }}</span
      >
      <!-- <ng-container *ngIf="reserva.HoraEntrada; else sinPaseHorario">
        <span>{{ reserva.FechaHoraEntrada }} </span>
      </ng-container> -->
      <span *ngFor="let sesion of filtrarRecintos(reserva.ReservaRecintos)">
        <!-- <span  *ngIf="sesion.Espectaculo.length > 0">
          {{ sesion.Espectaculo }}
        </span>
        <span *ngIf="sesion.NumFila.length > 0 &&  sesion.NumButaca.length > 0 "
                      >Fila: {{ sesion.NumFila }} Butaca:
                      {{ sesion.NumButaca }}</span
                    > -->
        <span *ngIf="sesion.RecintoNombre"
          >{{ sesion.RecintoNombre }} - {{ sesion.FechaEntrada }} ({{
            sesion.CantidadXRecinto
          }})</span
        >
      </span>
      <ng-template #sinPaseHorario>
        <span>{{ 'SIN_SELECCION_PASE_HORARIO' | translateV2 }}</span>
      </ng-template>
    </perfect-scrollbar>

    <div *ngFor="let producto of reserva.ProductosCompra">
      <span *ngFor="let aforo of producto.AforosConsumidos">
        {{ aforo.NombreRecinto }} ({{ aforo.TotalAforo }})</span
      >
    </div>
    <span *ngFor="let sesion of filtrarRecintos(reserva.ReservaRecintos)">
      <!-- <span  *ngIf="sesion.Espectaculo.length > 0">
        {{ sesion.Espectaculo }}
      </span>
      <span *ngIf="sesion.NumFila.length > 0 &&  sesion.NumButaca.length > 0 "
                    >Fila: {{ sesion.NumFila }} Butaca:
                    {{ sesion.NumButaca }}</span
                  > -->
      <span *ngIf="sesion.RecintoNombre"
        >{{ sesion.RecintoNombre }} - {{ sesion.FechaEntrada }} ({{
          sesion.CantidadXRecinto
        }})</span
      >
    </span>
  </div>
  <fieldset>
    <div class="white-box" *ngIf="reserva">
      <div class="Rtable">
        <div class="Rtable-row Rtable-row--head">
          <div class="Rtable-row-inner">
            <div class="Rtable-cell item-cell column-heading">
              {{ 'OBJETO' | translate }}
            </div>
            <div class="Rtable-cell cantidad-cell column-heading">
              {{ 'CANT' | translate }}
            </div>
            <div class="Rtable-cell precio-cell column-heading">
              {{ 'TOTAL' | translate }}
            </div>
          </div>
        </div>
        <perfect-scrollbar class="detailScroll ps--active-y">
          <div class="Rtable-row" *ngFor="let item of items">
            <div class="Rtable-row-inner">
              <div class="Rtable-cell item-cell">
                <div class="Rtable-cell--content item-content">
                  {{ item.entrada.NombrePantalla }}
                </div>
              </div>
              <div class="Rtable-cell Rtable-cell--foot cantidad-cell">
                <div class="Rtable-cell--content cantidad-content">
                  <div class="quantity">
                    <input
                      type="number"
                      class="qty text"
                      step="1"
                      min="0"
                      name="quantity"
                      value="{{ item.cantidad }}"
                      title="Cantidad"
                      size="4"
                      disabled
                    />
                  </div>
                </div>
              </div>
              <div class="Rtable-cell precio-cell">
                <div class="Rtable-cell--content precio-content">
                  {{
                    item.entrada.PrecioTotal
                      | myCurrency
                        : divisaSimboloDecimal
                        : divisaDecimales
                        : divisaPosicion
                        : divisaSimbolo
                        : divisaSimboloDerecha
                        : divisaSimbSeparacionMiles
                  }}
                  <!-- {{ calcularPrecioTotal(item.entrada) | number: '1.2-2' }} -->
                  {{ divisaSimbolo }}
                </div>
              </div>
              <div class="Rtable-cell delete-cell">
                <div class="Rtable-cell--content delete-content">
                  <a title="Borrar" style="background-color: #f3f5f7"> </a>
                </div>
              </div>
            </div>

            <div
              *ngIf="item.entrada['PromocionEntradas']"
              class="resumenDescuentos"
            >
              <!-- <span *ngFor="let promocion of item.entrada['PromocionEntradas']" -->
              <span
                *ngFor="let promocion of filtrarSolo1Promocion(item.entrada)"
                >* {{ promocion.NombreTipo }}
              </span>
            </div>
          </div>
        </perfect-scrollbar>
      </div>
    </div>
  </fieldset>
  <div class="NumpadWrap" *ngIf="reserva">
    <div class="totales">
      <div class="titulos">
        <span>{{ 'CANTIDAD' | translate }}</span>
        <span>{{ 'TOTAL' | translate }}</span>
      </div>
      <div class="numeros">
        <span>{{ cantidadProductos }}</span>
        <span>
          {{
            totalReserva
              | myCurrency
                : divisaSimboloDecimal
                : divisaDecimales
                : divisaPosicion
                : divisaSimbolo
                : divisaSimboloDerecha
                : divisaSimbSeparacionMiles
          }}
        </span>
      </div>
    </div>
    <button
      *ngIf="reserva"
      [ngClass]="{ disabled: !sePuedeFinalizar }"
      (click)="finalizarVenta()"
      type="button"
      value="PAGAR"
      class="pagar"
    >
      {{ 'FINALIZAR' | translateV2 }}
    </button>
  </div>
</section>
<ticketing-motivos-localizador
  *ngIf="itemsConMotivo"
  [entradas]="itemsConMotivo"
  id="motivosLocalizador"
  style="display: none"
></ticketing-motivos-localizador>
